import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const EASE = [0.16, 1, 0.3, 1];

export const Faq = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });

  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-36 border-t border-white/5">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
        >
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-mint mb-4">{t("faq.kicker")}</p>
          <h2 className="font-display font-semibold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl text-balance">
            {t("faq.title")}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-white/8 bg-card px-6 data-[state=open]:border-mint/25 transition-colors duration-300"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-medium text-white text-base lg:text-lg hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-sm lg:text-base text-white/55 leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
